import axios from "axios";
import { API_URL } from "@/config/api";
import { betterAuthEnabled, getBetterAuthClient, checkAuthResult } from './betterAuthClient';

const axiosInstance = axios.create({
  baseURL: API_URL,
  withCredentials: true,
});

export const authService = {
  async login(email, password) {
    if (betterAuthEnabled) {
      checkAuthResult(await getBetterAuthClient().signIn.email({ email, password }));
      return { data: { user: await this.getCurrentUser() } };
    }
    const response = await axiosInstance.post("/login", {
      email,
      password,
    });
    return response.data;
  },

  async getCurrentUser() {
    const response = await axiosInstance.get("/me");
    // el primer data es de axios, el segundo es del backend
    return response.data.data.user;
  },

  async selectTeam(teamUuid) {
    const response = await axiosInstance.post("/session/team", {
      team_uuid: teamUuid,
    });
    return response.data.data.user;
  },

  async logout() {
    if (betterAuthEnabled) {
      checkAuthResult(await getBetterAuthClient().signOut());
      return;
    }
    await axiosInstance.post("/logout");
  },
  async google(link = false) {
    const options = { provider: 'google', callbackURL: `${window.location.origin}/#/auth-callback`, errorCallbackURL: `${window.location.origin}/#/auth-callback` };
    return checkAuthResult(await (link ? getBetterAuthClient().linkSocial(options) : getBetterAuthClient().signIn.social(options)));
  },
  async authStatus() { return (await axiosInstance.get('/auth/status')).data.data; },
  async localAuthStatus() { return (await axiosInstance.get('/local-auth/status')).data.data; },
  async completeOnboarding(profile) { return (await axiosInstance.post('/auth/onboarding', profile)).data.data.user; },
};
